import { render } from "./Ampel.pug?vue&type=template&id=a4b64e6e&lang=pug"
import script from "./Ampel.js?vue&type=script&lang=js"
export * from "./Ampel.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__